<template>
  <HeadingDisplay v-if="isProduct" title="" size="small">
    <template #heading-component>
      <BaseText
        class="card-main__heading"
        :color="NebraskaColors.elementPrimary"
      >
        {{ card.title }}
      </BaseText>
    </template>
    <template #title-component>
      <Money>
        <BaseText size="xxl" as="p" :color="textColor">
          {{ card.amount?.formatted }}
        </BaseText>
      </Money>
    </template>
  </HeadingDisplay>
  <BaseText v-else size="xxl" as="p" :color="NebraskaColors.elementPrimary">
    {{ card.title }}
  </BaseText>
</template>
<script setup lang="ts">
import { HeadingDisplay, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { computed } from 'vue';
import { Money } from '@/modules/common/components/Money';
import {
  EProductViewCardType,
  IProduct
} from '@/modules/products/services/products';

interface Props {
  card: IProduct;
}
const props = defineProps<Props>();

const isProduct = computed(
  () => props.card.type === EProductViewCardType.Product
);

const textColor = computed<NebraskaColors>(() =>
  props.card.amount!.value > 0
    ? NebraskaColors.elementPrimary
    : NebraskaColors.elementPlaceholder
);
</script>

<style lang="less" scoped>
.card-main {
  &__heading {
    font-weight: 600;
  }
}
</style>
